import React from "react";
import classes from "./Footer.module.scss";
import Container from "../../commoncomponents/Container/Container";
import NavigationMenu from "./NavigationMenu/NavigationMenu";
import { Grid } from "@mui/material";
import footerlogo from "/assets/mahi_dental_logo.jpg";
import { Link } from "react-router-dom";

const Footer = () => {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <>
      <div className={`${classes.footerbg}`}>
        <Container>
          <Grid
            container
            rowSpacing={{ xs: 3, sm: 0, md: 0, lg: 0 }}
            columnSpacing={{ xs: 0, sm: 2, md: 0, lg: 3 }}
            className="!mt-0"
          >
            <Grid item xs={12} sm={4.5} md={4.5} lg={5}>
              <div className={`${classes.footerImg}`}>
                <img alt="Mahi Dental Clinic Logo - Dental Services in Gandhinagar" src={footerlogo} className="w-[108px] rounded-md" />
              </div>
              <div className={`${classes.footerDivide}`}>
                <h2 className={`${classes.footerHeading}`}>
                  MAHI DENTAL CLINIC
                </h2>
                <p className={`${classes.footerText}`}>
                  Mahi Dental Clinic has more than 2000+ satisfied patients. Mahi Dental Clinic Sector 7 Gandhinagar-Gujarat, our clinic provides world-class dental treatment using Advance dental instruments, delivered by a highly trained and experienced team of specialist dentists. With a strong 4.9/5 rating from our patients, we are known for delivering high-quality, patient-centered care and outstanding results, we’re committed to excellence in every service.
                  Best Dental Clinic in Gandhinagar.
                  Best Dentist in Gandhinagar, Dental Clinic Near Me
                </p>
              </div>
            </Grid>

            <Grid item xs={12} sm={5.5} md={5.5} lg={4}>
              <div className={`${classes.footerDivide}`}>
                <NavigationMenu />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={2} lg={3}>
            <h4 className={`${classes.footerHeading} !mb-2 !mt-2`}>Our Location</h4>
              <div className={classes.footerMap}>
                <iframe
                  title="Mahi Dental Clinic Location"
                  src="https://www.google.com/maps?q=Mahi+Dental+Clinic+Sector+7+Gandhinagar&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0, borderRadius: "12px" }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className={`${classes.footerBottombg}`}>
        <Container>
          <p className={`${classes.copyrightText}`}>
            Copyright &copy; {getCurrentYear()} Mahi Dental Clinic.
            All rights reserved | Designed & Developed by <a href="/" target="_blank" rel="noopener noreferrer" className="underline hover:text-black"> Sujal & Vihar</a>
          </p>
        </Container>
      </div>
    </>
  );
};

export default Footer;
